<template>
  <v-layout
    align-center
    justify-end
  >
    <span
      v-if="author"
      class="caption grey--text text--lighten-1 text-xs-right label-author"
    >{{ author | shortName }}</span>
    <template v-for="(label, index) in labels">
      <v-tooltip
        v-if="label.tooltip"
        :key="index"
        top
      >
        <template v-slot:activator="{ on }">
          <v-chip
            text-color="white"
            label
            small
            :color="label.color"
            class="mr-0"
            v-on="on"
          >
            {{ label.shortTitle || "" }}
          </v-chip>
        </template>
        <span>{{ label.title }}</span>
      </v-tooltip>
      <v-chip
        v-else
        :key="index"
        top
        text-color="white"
        label
        small
        :color="label.color"
        class="mr-0"
      >
        {{ label.shortTitle || "" }}
      </v-chip>
    </template>
  </v-layout>
</template>
<script>
export default {
  props: ["labels", "author"],
};
</script>
